var parser = require('./parser').parser

module.exports = function (argument) {
  return parser.parse(argument)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/spdx-expression-parse/index.js
// module id = 222
// module chunks = 0